webpackJsonp([1],{

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Configuration Data
var vibratePattern = [100, 50, 100, 50, 100];
var notificationTag = 'pomodori-notification';
var notificationIcon = '/static/img/icons/icon-192x192.png';
var renotifyOption = 'true';

var supported = function supported() {
  return 'Notification' in window && window.Notification !== undefined;
};
var isBlocked = function isBlocked() {
  return 'Notification' in window && window.Notification.permission === 'denied';
};
var isEnabled = function isEnabled() {
  return 'Notification' in window && window.Notification.permission === 'granted';
};

var requestPermission = function requestPermission() {
  if (supported() && window.Notification.permission === 'default') {
    window.Notification.requestPermission();
  }
};

var sendNotification = function sendNotification(msgTitle, msgBody) {
  if (supported() && window.Notification.permission === 'granted') {
    // send notification via service workers (for browsers w/ service worker installed)
    if (navigator.serviceWorker.controller !== null) {
      navigator.serviceWorker.ready.then(function (registration) {
        registration.showNotification(msgTitle, {
          body: msgBody,
          icon: notificationIcon,
          vibrate: vibratePattern,
          tag: notificationTag,
          renotify: renotifyOption
        });
      });
    } else {
      new window.Notification(msgTitle, { // eslint-disable-line no-new
        body: msgBody,
        icon: notificationIcon,
        vibrate: vibratePattern,
        tag: notificationTag,
        renotify: renotifyOption
      });
    }

    return true;
  }
  return false;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  supported: supported,
  isBlocked: isBlocked,
  isEnabled: isEnabled,
  requestPermission: requestPermission,
  sendNotification: sendNotification
});

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);

/* eslint-disable no-console */


var APP_VERSION = 2.1;
var STORAGE_KEY = 'settings';
var STORAGE_NAME = 'pomodori-v2.1.0-storage';

var configStorage = function configStorage() {
  __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.config({
    driver: __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.LOCALSTORAGE,
    name: STORAGE_NAME,
    version: APP_VERSION
  });
};

var loadSettings = function loadSettings() {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem(STORAGE_KEY).then(function (value) {
      resolve(value);
    }).catch(function (err) {
      reject(err);
    });
  });
};

var saveSettings = function saveSettings(settings) {
  __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem(STORAGE_KEY, settings);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  configStorage: configStorage,
  loadSettings: loadSettings,
  saveSettings: saveSettings
});

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(86),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  WORK_START: { mode: 'work', status: 'init' },
  WORK: { mode: 'work', status: 'active' },
  WORK_PAUSED: { mode: 'work', status: 'inactive' },
  BREAK_START: { mode: 'break', status: 'init' },
  BREAK: { mode: 'break', status: 'active' },
  BREAK_PAUSED: { mode: 'break', status: 'inactive' },
  GET_MODE: function GET_MODE(inputState) {
    return inputState.mode;
  },
  GET_STATUS: function GET_STATUS(inputState) {
    return inputState.status;
  },
  START: function START(inputState) {
    var temp = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(inputState);
    temp.status = 'active';
    return temp;
  },
  PAUSE: function PAUSE(inputState) {
    var temp = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(inputState);
    temp.status = 'inactive';
    return temp;
  },
  RESET: function RESET(inputState) {
    var temp = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(inputState);
    temp.status = 'init';
    return temp;
  },
  SWITCH: function SWITCH(inputState) {
    var temp = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(inputState);
    temp.mode = temp.mode === 'break' ? 'work' : 'break';
    temp.status = 'init';
    return temp;
  }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_touch__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_muse_ui__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_muse_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_muse_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_muse_ui_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_muse_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_muse_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_radialBar__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_radialBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_radialBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SettingsView__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SettingsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SettingsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_notifications__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_stateMachine__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_storage__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_muse_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_touch___default.a, { name: 'v-touch' });

var CLOCK_DELAY = 1000;
var FAST_FORWARD_TIME_DELAY = 1;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    radialBar: __WEBPACK_IMPORTED_MODULE_5__components_radialBar___default.a,
    settings: __WEBPACK_IMPORTED_MODULE_6__components_SettingsView___default.a
  },
  data: function data() {
    return {
      // app State
      timeRemaining: 1500,
      state: __WEBPACK_IMPORTED_MODULE_8__modules_stateMachine__["a" /* default */].WORK_START,
      showSettingsView: false,
      // app Settings
      workDuration: 1500,
      breakDuration: 300,
      allowNotification: true && !__WEBPACK_IMPORTED_MODULE_7__modules_notifications__["a" /* default */].isBlocked(),
      // worker objects for our timer
      timerWorker: null,
      alarmWorker: null,
      // data used for responsiveness
      radialBarSize: 300
    };
  },

  computed: {
    overlayText: function overlayText() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(this.timeRemaining / 60).floor().padStart(2, '0') + ':' + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(this.timeRemaining % 60).padStart(2, '0');
    },
    fractionOfTimeLeft: function fractionOfTimeLeft() {
      return this.state.mode === 'work' ? this.timeRemaining / this.workDuration : this.timeRemaining / this.breakDuration;
    },

    // computes the data of the primaryButton at any given [state]
    primaryButton: function primaryButton() {
      var _this = this;

      var primaryBtn = {};
      switch (this.state.status) {
        case 'init':
          primaryBtn.text = 'START';break;
        case 'active':
          primaryBtn.text = 'STOP';break;
        case 'inactive':
          primaryBtn.text = 'RESUME';break;
        default:
      }
      primaryBtn.text += this.state.mode === 'work' ? ' WORKING' : ' MY BREAK';
      primaryBtn.bgColor = this.state.mode === 'work' ? '#2196F3' : '#7CB342';
      primaryBtn.callbackFn = this.state.status === 'active' ? function () {
        _this.pauseTimer();
      } : function () {
        _this.startTimer();
      };
      return primaryBtn;
    }
  },
  methods: {
    startTimer: function startTimer() {
      var _this2 = this;

      this.state = __WEBPACK_IMPORTED_MODULE_8__modules_stateMachine__["a" /* default */].START(this.state);

      if (this.timerWorker === null) {
        this.timerWorker = setInterval(function () {
          _this2.timeRemaining -= 1;
          if (_this2.timeRemaining <= 0) {
            _this2.triggerAlarm();
          }
        }, CLOCK_DELAY);
      }
    },
    pauseTimer: function pauseTimer() {
      this.clearTimeWorker();
      this.state = __WEBPACK_IMPORTED_MODULE_8__modules_stateMachine__["a" /* default */].PAUSE(this.state);
    },
    resetTimer: function resetTimer() {
      this.clearTimeWorker();
      this.state = __WEBPACK_IMPORTED_MODULE_8__modules_stateMachine__["a" /* default */].RESET(this.state);
      this.timeRemaining = this.state.mode === 'work' ? this.workDuration : this.breakDuration;
    },
    triggerAlarm: function triggerAlarm() {
      this.clearTimeWorker();
      this.state = __WEBPACK_IMPORTED_MODULE_8__modules_stateMachine__["a" /* default */].SWITCH(this.state);
      this.timeRemaining = this.state.mode === 'work' ? this.workDuration : this.breakDuration;
      var startBreakMessage = { title: 'Stop working already!', body: 'Time to start your break...' };
      var backToWorkMessage = { title: 'Your break is over!', body: 'Time to get back to work...' };

      if (this.allowNotification === true) {
        __WEBPACK_IMPORTED_MODULE_7__modules_notifications__["a" /* default */].requestPermission();
        __WEBPACK_IMPORTED_MODULE_7__modules_notifications__["a" /* default */].sendNotification(this.state.mode === 'work' ? backToWorkMessage.title : startBreakMessage.title, this.state.mode === 'work' ? backToWorkMessage.body : startBreakMessage.body);
      }
    },
    switchToSettingsView: function switchToSettingsView() {
      this.pauseTimer();
      this.showSettingsView = true;
    },
    switchToMainView: function switchToMainView(event) {
      this.workDuration = event.workDuration;
      this.breakDuration = event.breakDuration;
      this.allowNotification = event.allowNotification;
      this.resetTimer();
      this.showSettingsView = false;
    },

    // [PRIVATE] terminates the timerWorker
    clearTimeWorker: function clearTimeWorker() {
      clearInterval(this.timerWorker);
      this.timerWorker = null;
    },

    // [PRIVATE] helper method to access STATE object
    getStateHelper: function getStateHelper() {
      return __WEBPACK_IMPORTED_MODULE_8__modules_stateMachine__["a" /* default */];
    },

    // [PRIVATE] callback for WINDOW_RESIZE event,
    //           resizes the radialBar component for the new viewport dimension
    handleResize: function handleResize() {
      var paddingPercentage = 0.2;
      var newRadialBarDivHeight = 0.75 * document.documentElement.clientHeight;
      var newRadialBarDivWidth = document.documentElement.clientWidth;

      this.radialBarSize = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.min([newRadialBarDivHeight, newRadialBarDivWidth]) * (1 - paddingPercentage);
    },
    fastForwardTime: function fastForwardTime() {
      var _this3 = this;

      this.clearTimeWorker();
      this.timerWorker = setInterval(function () {
        _this3.timeRemaining -= 1;
        if (_this3.timeRemaining <= 0) {
          _this3.triggerAlarm();
        }
      }, FAST_FORWARD_TIME_DELAY);
    },
    resetClockDelay: function resetClockDelay() {
      var _this4 = this;

      this.clearTimeWorker();
      this.timerWorker = setInterval(function () {
        _this4.timeRemaining -= 1;
        if (_this4.timeRemaining <= 0) {
          _this4.triggerAlarm();
        }
      }, CLOCK_DELAY);
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    // Listener to resize our radialBar when user changes the browser window size
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // Configure storage settings (required by localforage)
    __WEBPACK_IMPORTED_MODULE_9__modules_storage__["a" /* default */].configStorage();

    // Load user settings from storage module
    __WEBPACK_IMPORTED_MODULE_9__modules_storage__["a" /* default */].loadSettings().then(function (userSettings) {
      if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(userSettings)) {
        var workDuration = userSettings.workDuration,
            breakDuration = userSettings.breakDuration,
            allowNotification = userSettings.allowNotification;

        _this5.workDuration = workDuration;
        _this5.breakDuration = breakDuration;
        _this5.allowNotification = allowNotification && !__WEBPACK_IMPORTED_MODULE_7__modules_notifications__["a" /* default */].isBlocked();

        // Update `timeRemaining` to newly loaded `workDuration`
        _this5.timeRemaining = workDuration;
      }
    }).catch(function () {});

    // Request for permission to send local notifications
    __WEBPACK_IMPORTED_MODULE_7__modules_notifications__["a" /* default */].requestPermission();
  },

  // remove event handler before the component is destroyed
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_muse_ui__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_muse_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_muse_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_muse_ui_dist_muse_ui_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_muse_ui_dist_muse_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_muse_ui_dist_muse_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_notifications__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_storage__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_muse_ui___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings',
  props: {
    workDuration: { type: Number, required: true },
    breakDuration: { type: Number, required: true },
    allowNotification: { type: Boolean, required: true }
  },
  data: function data() {
    return {
      myWorkDuration: this.workDuration,
      myBreakDuration: this.breakDuration,
      myAllowNotification: this.allowNotification
    };
  },

  watch: {
    workDuration: function workDuration(newValue) {
      this.myWorkDuration = newValue;
    },
    breakDuration: function breakDuration(newValue) {
      this.myBreakDuration = newValue;
    },
    allowNotification: function allowNotification(newValue) {
      this.myAllowNotification = newValue;
    }
  },
  computed: {
    disableNotificationSetting: function disableNotificationSetting() {
      return !__WEBPACK_IMPORTED_MODULE_3__modules_notifications__["a" /* default */].supported() || __WEBPACK_IMPORTED_MODULE_3__modules_notifications__["a" /* default */].isBlocked();
    },
    notificationSettingDescription: function notificationSettingDescription() {
      if (!__WEBPACK_IMPORTED_MODULE_3__modules_notifications__["a" /* default */].supported()) {
        return 'Your browser does not support notifications';
      } else if (__WEBPACK_IMPORTED_MODULE_3__modules_notifications__["a" /* default */].isBlocked()) {
        return 'Please unblock notifications via your browser settings';
      }

      return this.myAllowNotification ? 'You will be notified when timer reaches zero' : 'You will NOT be notified when timer reaches zero';
    }
  },
  methods: {
    backToAppView: function backToAppView() {
      var settings = {
        workDuration: this.myWorkDuration,
        breakDuration: this.myBreakDuration,
        allowNotification: this.myAllowNotification
      };
      this.$emit('change', settings);
      __WEBPACK_IMPORTED_MODULE_4__modules_storage__["a" /* default */].saveSettings(settings);
    }
  },
  filters: {
    toMinutes: function toMinutes(value, text) {
      return text + ' (' + value / 60 + ' min)';
    }
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'radialBar',
  props: {
    fraction: {
      validator: function validator(value) {
        return !isNaN(value) && value >= 0 && value <= 1;
      },

      required: true
    },
    overlayText: {
      type: String,
      required: true
    },
    // Validate if string is #XXXXXX format
    strokeColor: {
      validator: function validator(value) {
        return (/^#[0-9A-F]{6}$/i.test(value)
        );
      },

      required: true
    },
    // Validate if string is #XXXXXX format
    trailColor: {
      validator: function validator(value) {
        return (/^#[0-9A-F]{6}$/i.test(value)
        );
      },

      required: true
    },
    size: {
      type: Number,
      required: true
    }
  },
  computed: {
    // Computes the linear-gradient values to display the corresponding [fraction] prop
    radialBarArc: function radialBarArc() {
      if (this.fraction > 0.5) {
        // @this.fraction = 1.00, computedAngle = -90deg
        // @this.fraction = 0.75, computedAngle =   0deg
        // @this.fraction = 0.50, computedAngle =  90deg
        var _computedAngle = 270 - this.fraction * 360;
        return {
          'background-image': 'linear-gradient(' + _computedAngle + 'deg, ' + this.strokeColor + ' 50%, transparent 50%, transparent), linear-gradient(90deg, ' + this.strokeColor + ' 50%, ' + this.trailColor + ' 50%, ' + this.trailColor + ')'
        };
      }

      // @this.fraction = 0.50, computedAngle =  90deg
      // @this.fraction = 0.25, computedAngle = 180deg
      // @this.fraction = 0.00, computedAngle = 270deg
      var computedAngle = 270 - this.fraction * 360;
      return {
        'background-image': 'linear-gradient(270deg, ' + this.trailColor + ' 50%, transparent 50%, transparent), linear-gradient(' + computedAngle + 'deg, ' + this.strokeColor + ' 50%, ' + this.trailColor + ' 50%, ' + this.trailColor + ')'
      };
    },

    // Compute CSS to scale the component based on the [size] prop
    computedStyle: function computedStyle() {
      var strokeWidth = this.size * 0.08;
      var overlayTextSize = this.size * 0.3;
      var overlaySize = this.size - strokeWidth;
      var overlayMargin = strokeWidth / 2;
      return {
        radialBar: {
          height: this.size + 'px',
          width: this.size + 'px'
        },
        overlay: {
          height: overlaySize + 'px',
          width: overlaySize + 'px',
          lineHeight: overlaySize + 'px',
          margin: overlayMargin + 'px',
          fontSize: overlayTextSize + 'px'
        }
      };
    }
  }
});

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(87),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(88),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "MainView"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('v-touch', {
    staticClass: "logo-overlay",
    on: {
      "press": _vm.fastForwardTime,
      "pressup": _vm.resetClockDelay
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Pomodori Logo",
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "settings"
    },
    on: {
      "click": _vm.switchToSettingsView
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('radialBar', {
    attrs: {
      "fraction": _vm.fractionOfTimeLeft,
      "overlayText": _vm.overlayText,
      "size": _vm.radialBarSize,
      "strokeColor": _vm.primaryButton.bgColor,
      "trailColor": "#ABABAB"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-raised-button', {
    staticClass: "resetButton",
    attrs: {
      "label": "RESET",
      "color": _vm.primaryButton.bgColor
    },
    on: {
      "click": _vm.resetTimer
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "primaryButton",
    attrs: {
      "label": _vm.primaryButton.text,
      "backgroundColor": _vm.primaryButton.bgColor
    },
    on: {
      "click": _vm.primaryButton.callbackFn
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSettingsView),
      expression: "showSettingsView"
    }],
    staticClass: "SettingsView"
  }, [_c('settings', {
    ref: "settings",
    attrs: {
      "allowNotification": _vm.allowNotification,
      "breakDuration": _vm.breakDuration,
      "workDuration": _vm.workDuration
    },
    on: {
      "change": _vm.switchToMainView
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('mu-appbar', {
    attrs: {
      "title": "Settings"
    }
  }, [_c('mu-icon-button', {
    staticClass: "backButton",
    attrs: {
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.backToAppView
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list', [_c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "describeText": _vm._f("toMinutes")(_vm.myWorkDuration, 'Work Duration')
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "access_alarm"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-slider', {
    attrs: {
      "step": 60,
      "min": 60,
      "max": 3600
    },
    model: {
      value: (_vm.myWorkDuration),
      callback: function($$v) {
        _vm.myWorkDuration = $$v
      },
      expression: "myWorkDuration"
    }
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "describeText": _vm._f("toMinutes")(_vm.myBreakDuration, 'Break Duration')
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "videogame_asset"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-slider', {
    attrs: {
      "step": 60,
      "min": 60,
      "max": 3600
    },
    model: {
      value: (_vm.myBreakDuration),
      callback: function($$v) {
        _vm.myBreakDuration = $$v
      },
      expression: "myBreakDuration"
    }
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "title": "Push Notifications",
      "describeText": _vm.notificationSettingDescription
    }
  }, [_c('mu-switch', {
    attrs: {
      "disabled": _vm.disableNotificationSetting
    },
    slot: "right",
    model: {
      value: (_vm.myAllowNotification),
      callback: function($$v) {
        _vm.myAllowNotification = $$v
      },
      expression: "myAllowNotification"
    }
  })], 1), _vm._v(" "), _c('mu-divider')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radialBar",
    style: (_vm.computedStyle.radialBar)
  }, [_c('div', {
    staticClass: "radialBar-progress",
    style: (_vm.radialBarArc)
  }, [_c('div', {
    staticClass: "radialBar-overlay",
    style: (_vm.computedStyle.overlay)
  }, [_vm._v(_vm._s(_vm.overlayText))])])])
},staticRenderFns: []}

/***/ })

},[40]);


// WEBPACK FOOTER //
// static/js/app.cacd8ff2f21923fff82d.js